"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var intl_1 = require("./lib/extension/intl");
exports.TwingExtensionIntl = intl_1.TwingExtensionIntl;
